<template>
    <div class="d-flex align-center flex-column justify-start fill-height" style="width: 100% !important;">
        <v-container fluid width=100% class="lightgrey pa-5">
            <v-card flat color="lightgrey" height=100%>
                <v-row class="pt-4 px-4">
                    <v-col cols="2" md="1" lg="1" class="d-flex align-center">
                        <v-row> 
                            <div v-if="sensors.leaf_moisture < 1 && sensors.windspeed <10"> <v-icon size="40" color="success" position="center" class="pl-2">icons8-insecticide</v-icon> </div>
                            <div v-else-if="sensors.leaf_moisture >= 1"> <v-icon size="40" color="error" position="center" class="pl-2">icons8-insecticide</v-icon> </div>
                            <div v-else-if="sensors.windspeed >=10"> <v-icon size="40" color="error" position="center" class="pl-2">icons8-insecticide</v-icon> </div>
                            <div v-else> <v-icon size="40" color="grey" position="center" class="pl-2">icons8-insecticide</v-icon> </div>
                        </v-row>
                    </v-col>
                    <v-col cols="10">
                        <div class=""> 
                            <div v-if="sensors.leaf_moisture < 1 && sensors.windspeed <10"> <h3 class="font-weight-normal success--text">{{ $t('menu.pesticide') }}</h3> </div>
                            <div v-else-if="sensors.leaf_moisture >= 1"> <h3 class="font-weight-normal error--text">{{ $t('menu.pesticide') }}</h3> </div>
                            <div v-else-if="sensors.windspeed >=10"> <h3 class="font-weight-normal error--text">{{ $t('menu.pesticide') }}</h3> </div>
                            <div v-else> <h3 class="font-weight-normal">{{ $t('menu.pesticide') }}</h3> </div>
                            <div class=""> <h5><span v-if="JSON.stringify(station) !== '{}'">{{ station.station_name }} </span></h5> </div>
                        </div>    
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <v-row class="pt-3" style="width: 100% !important;">    
            <v-col cols="12" xs="12" sm="6" md="5" lg="4">
                <dashcard :currentdata="currentData.windspeed" :key="currentData.componentKey" />
                <dashcard :currentdata="currentData.leafMoisture" :key="currentData.componentKey" />
                <forecast :currentdata="currentData.weatherForecast" :key="currentData.weatherForecast.componentKey" />
                
                <!-- <v-card flat color="appbackground" width=100% height="130" class="pt-4 pa-2"> 
                    <weatherforecast />
                </v-card>  -->

                <div v-if="sensors.leaf_moisture < 1 && sensors.windspeed <10">
                    <v-btn block depressed large @click="MIX_logActivity('pesticideSpreading', station, currentData), overlay = !overlay" color="success" class="mt-3">{{ $t('buttons.activity') }}</v-btn>
                </div>

                <v-btn block depressed large @click="MIX_go('/farming')" class="mt-3 lightgrey">{{ $t('buttons.back') }}</v-btn>

                <v-overlay :value="overlay">
                    <v-card color="appbackground" flat style="width: 75vw impo !important">
                        <overlay :currentdata="currentData" :key="currentData.componentKey" :showButton="true"/>
                        <v-col cols=12 class="">
                            <v-btn block depressed large @click="overlay = false" class="lightgrey darktext--text">{{ $t('buttons.back') }}</v-btn>   
                        </v-col>             
                    </v-card>
                </v-overlay>

            </v-col>
        </v-row>
    </div> 
</template>

<script>

import { mapGetters } from 'vuex'; // Map Actions / Getters
export default {
    name: 'FertiliserSpreading',
    data: () => ({
        items: ['Gelli Aur', 'Example 1', 'Example 2'],
        station: {},
        current: [],
        overlay: false,
        sensors: {
            windspeed: '-',
            leaf_moisture: '-',
        },
        currentData: {
            activity: {
                title: 'menu.pesticide'
            },
            windspeed: { 
                title: 'weather.windSpeed',
                subtitle: 'All Year',
                unit: "mph",
                icon: 'icons8-windsock',
                value: '-',
                status: 'grey',
                componentKey: 0,
            },
            leafMoisture: { 
                title: 'weather.leafMoisture',
                subtitle: 'All Year',
                icon: 'icons8-leaf',
                value: '-',
                status: 'grey',
                componentKey: 1,
            },
            weatherForecast: {
                value: [],
                componentKey: 2
            }
        }
    }),
    computed: {
        ...mapGetters({
                GET_weatherDataStations: 'GET_weatherDataStations',
                GET_weatherDataStationById: 'GET_weatherDataStationById',
                GET_weatherDataCurrent: 'GET_weatherDataCurrent',
        }),
    },
    methods: {
        convertToCelcius: function (value) {
          if (!value) return ''
          return parseFloat(((5/9) * (parseFloat(value) - 32)).toFixed())
        },  
        getSensor: function(sensor_type) {
            return this.current.find(sensor => parseInt(sensor.sensor_type) === parseInt(sensor_type) )
        },
        updateSensors() {
            var t = this;    
            t.sensors.windspeed = parseFloat(t.getSensor(28).data[0].wind_speed)  
            t.sensors.windspeedUpdated = t.getSensor(28).data[0].ts;
            t.sensors.leaf_moisture = parseFloat(t.getSensor(104).data[0].wetness_last)  
            t.sensors.leafMoistureUpdated = t.getSensor(104).data[0].ts;
        },
        updateWindspeed() {
            var t = this;
            t.currentData.windspeed.value = parseFloat(t.getSensor(28).data[0].wind_speed) 
            t.currentData.windspeed.subtitle = t.MIX_formatDateTime(t.getSensor(28).data[0].ts, 'X', 'DD-MMM-YY HH:mm:ss')
            if (t.currentData.windspeed.value >= 10) {
                t.currentData.windspeed.status = 'error' 
            } else {
                t.currentData.windspeed.status = 'success'
            }
            t.currentData.windspeed.componentKey++
        },
        updateLeafMoisture() {
            var t = this;
            t.currentData.leafMoisture.value = parseFloat(t.getSensor(104).data[0].wetness_last)  
            t.currentData.leafMoisture.subtitle = t.MIX_formatDateTime(t.getSensor(104).data[0].ts, 'X', 'DD-MMM-YY HH:mm:ss')
            if (t.currentData.leafMoisture.value >= 1) {
                t.currentData.leafMoisture.status = 'error' 
            } else {
                t.currentData.leafMoisture.status = 'success'
            }
            t.currentData.leafMoisture.componentKey++
        },
        updateForecast: async function(lat, lon) {
            var t = this;
            var forecastResult = await t.MIX_weatherDataForecast(lat, lon)
            t.currentData.weatherForecast.value = forecastResult.data.daily
            t.currentData.weatherForecast.componentKey++
        },
    },
    async mounted () {
        var t = this;
        var routerPath = t.$route.path.split('/')
        var stationId = routerPath[2];
        t.station = await t.GET_weatherDataStationById(stationId);
        await t.MIX_weatherDataCurrent(stationId) 
        t.current = await t.GET_weatherDataCurrent;
        // console.log('got here')
        t.updateSensors();
        t.updateLeafMoisture();
        t.updateWindspeed();
        t.updateForecast(t.station.latitude, t.station.longitude);

    }
  }
</script>